/* ========================== */  
/* ========= import ========= */  
/* ========================== */ 
/* ====== React ====== */
import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { InputErrorMessage } from "./InputErrorMessage";

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------ セレクトボックス ------*/
const SselectRange = styled.select`		//セレクト
    height: 32px;
    margin: 2px 0;
    padding:0 5px;
    border-radius: 3px;
    border: ${ props => props.readOnly ? 'none' : 'solid 1px #C0C0C0'};
    appearance: ${props => props.readOnly ? 'none': '' };
    pointer-events:${props=>props.readOnly ? 'none' : 'cursor'};
    background-color:${props => props.readOnly ? 'transparent' : props.isDirty ? assets().color.lightYellow : 'white'};
    cursor: pointer;
    &:focus{
        outline: solid 1.5px #007BC3;
    };
    &:disabled{
        color:black;
        opacity:1;
        cursor: default;
        background-color:${props => props.readOnly ? 'transparent' : assets().color.disabled };
    };
    
    
`;
const SoptionRange = styled.option`	//選択肢（オプション）
    cursor: pointer;
`;
const SdivInputBox = styled.div`//セレクトボックスの枠
    display:flex;
    justify-content:center;
    align-items: center;
`;
const SdivInputBoxB = styled.div`//セレクトボックスの枠
    justify-content:center;
    align-items: center;
`;
const SdivInputTileLabel = styled.div`//入力項目のタイトル
    white-space: nowrap;
    display: flex;
    align-items: center;

`;
/* How To Use 
        <TableSelect
            errorMessage={error[payload]?.[items.name]?.message}
            defaultValue={dataRow[items.name]}
            register={register(`${payload}.${items.name}`,
            {
                required: items.required?CFArrayFount(inputCheckMaster.list,'value','required').label:'',
                required: '必須',
            })}
            range={items.range.list} //選択肢
            disabled={items.disabled}
            readOnly={items.readOnly}
        />
/> */

/*==================*/
/*=====  Main  =====*/
/*==================*/
/*------ エラー右に表示 ------*/
export const TableSelect = (props) => {

    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { boxStyle, errorMessage, defaultValue, range, register, id, disabled,readOnly,title, noHidden,isDirty } = props;

    /*--------------------------*/  
    /*------ Start Render ------*/  
    /*--------------------------*/  
    return (
            <SdivInputBox style={boxStyle}>
                {/* セレクトボックスタイトル */}
                {title?<SdivInputTileLabel className='baseText' style={{fontSize:assets().size.baseText}}>{title}</SdivInputTileLabel>:<></>}
                {/* セレクトボックス */}
                <SselectRange
                    className='inputText'
                    id={id}
                    isDirty={isDirty}
                    style={{fontSize:assets().size.baseText,height:assets().size.inputHeight}}
                    defaultValue={defaultValue}
                    disabled={disabled}
                    readOnly={readOnly}
                    {...register} 
                >
                    {/* 選択肢 */}
                    <option value="" hidden={noHidden ? false : true}>--選択--</option>
                    {range.map((list,index) => (
                        <SoptionRange
                            key={`${list.value}${index}`}
                            value={list.value}
                            className='baseText'
                            style={{fontSize:assets().size.baseText}}
                        >
                            {list.label}
                        </SoptionRange>
                    ))}
                </SselectRange>
                <InputErrorMessage errorMessage={errorMessage}/>
            </SdivInputBox>
    );
};

/*------ エラー下に表示 ------*/
export const TableSelectB = (props) => {

    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { boxStyle, errorMessage, defaultValue, range, register, id, disabled,readOnly, noHidden, isDirty } = props;
    /*--------------------------*/  
    /*------ Start Render ------*/  
    /*--------------------------*/  
    return (
            <SdivInputBoxB style={boxStyle}>
                {/* セレクトボックス */}
                <SselectRange
                    className='inputText'
                    id={id}
                    isDirty={isDirty}
                    style={{fontSize:assets().size.baseText,height:assets().size.inputHeight, width: '100%'}}
                    defaultValue={defaultValue}
                    disabled={disabled}
                    readOnly={readOnly}
                    {...register} 
                >
                    {/* 選択肢 */}
                    <option value="" hidden={noHidden ? false : true}>--選択--</option>
                    {range.map((year) => (
                        <SoptionRange
                            key={year.value}
                            value={year.value}
                            className='baseText'
                            style={{fontSize:assets().size.baseText}}
                        >
                            {year.label}
                        </SoptionRange>
                    ))}
                </SselectRange>
                {errorMessage ? <InputErrorMessage errorMessage={errorMessage}/> : ''}
            </SdivInputBoxB>
    );
};
